import React, { useEffect, useState } from 'react';

import { fabric } from 'fabric';
import { Loading } from '../../components/Loading';
import { CANVAS_CORNER_OPTION } from '../../../lib/const';
import { fetchClipArt} from '../ducks/clipart';
import { fetchClipArtCategory } from '../ducks/clipartCategory';
import { useDispatch, useSelector } from 'react-redux';

const ClipArtTool = ({canvas})=>{
    const dispatch = useDispatch();
    const clipartList = useSelector(state => state.clipartList);
    const clipartCategory = useSelector(state => state.clipartCategory);
    const [categoryCode, setCategoryCode] = useState('');
    const [mainCategory, setMainCategory] = useState('');
    const [subCategory, setSubCategory] = useState('');
    const [keyword, setKeyword] = useState('');

    useEffect(() => {
        dispatch( fetchClipArtCategory('') );
        fetchList( '', '', 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    function onChangeCategory(mainCate, subCate){
        let tempCode = (subCate==='')?mainCate:subCate;
        setMainCategory(mainCate)
        setSubCategory(subCate);
        setCategoryCode(tempCode);
        dispatch(fetchClipArtCategory(tempCode));
        fetchList(tempCode, keyword, 0);
    }

    function fetchList(categoryCode, keyword, page=0){
        dispatch( fetchClipArt(categoryCode, keyword, page) );
    }
    
    function onNextPage(){
        fetchList(categoryCode, keyword, clipartList.page+1);
    }
    
    function onInputFocus(event){
        canvas.discardActiveObject().renderAll();   
    }
    

    // 클립아트 추가
    function appendClipArt(clipart){
        // const img = event.target;
        // const url = img.src;
        const url = clipart.url
        if( undefined!==url && null!==url && url!=='' ){
            fabric.Image.fromURL(url, function(image) {
                    canvas.add(image);
                    // image.scaleX = image.scaleY = 0.5;
                    image.center();
                    image.set({...CANVAS_CORNER_OPTION});
                    canvas.setActiveObject(image);
                }
                ,null, { crossOrigin: 'Anonymous' }
                // , { crossOrigin: '' }
            );

            // SVG 라면
            // fabric.loadSVGFromURL('/static/images/picture/410.svg', function(objects, options) {
            //     objects.forEach(function(svg) {
            //        canvas.add(svg).renderAll();
            //     });
            //     canvas.add(new fabric.Group(objects));
            //  });
        }else{
            alert('스티커를 추가할수 없습니다.');
        }
        
    }


    function renderCategory(){
        let mainList = clipartCategory.main.map((category, key)=>{
            return <option key={category.code} value={category.code}>{category.name}</option>
        });
        mainList.unshift( <option key="mainNull" value="">1차 선택없음</option> );
        
        let subList = clipartCategory.sub.map((category, key)=>{
            return <option key={category.code} value={category.code}>{category.name}</option>
        });
        subList.unshift( <option key="subNull" value="">2차 선택없음</option> );

        return (
            <div className="categoryList">
                <select name="mainCategory" value={mainCategory} onChange={e=>onChangeCategory(e.target.value, '')}>
                    {mainList}
                </select>
                
                <select name="subCategory" value={subCategory} onChange={e=>onChangeCategory(mainCategory, e.target.value)}>
                    {subList}
                </select>
            </div>
        );
    }

    function renderClipArt(){
        return clipartList.list.map(function(clipart, key){
            if(null===clipart.url)return null;
            const thumbNailUrl = (null!==clipart && clipart.thumbnail.startsWith('http://') )?`${clipart.thumbnail}`:clipart.thumbnail;
            const imageUrl = (null!==clipart && clipart.url.startsWith('http://') )?`${clipart.url}`:clipart.url;
            return (
                <img src={thumbNailUrl} alt=""
                    data-url={imageUrl}
                    className="clipArt"
                    onClick={()=>{appendClipArt(clipart)} } key={key}
                    draggable="true"
                    onDragStart={event => {
                        event.dataTransfer.setData("url", imageUrl);
                        event.dataTransfer.setData("type", 'image');
                    }}
                 />
            );
        });
    }

    function renderMoreControl(){
        if(clipartList.loading )return <Loading />;
        if(clipartList.length===0){
            return <div className="noData">결과가 없습니다.</div>;
        }
        
        if( clipartList.page < (clipartList.totalPages-1) ){
            return <button className="btn _xsm _blue" onClick={onNextPage}>더 보기</button>
        }
    }

    if( null===canvas)return <Loading />
    return(
        <div className="clipArtContainer">
            <div className="search_area">
                <input type="text" name="keyword" placeholder="그림 검색" value={keyword} onChange={e=>setKeyword(e.target.value)}
                    onFocus={onInputFocus}
                    onKeyDown={ (event)=>{
                        if(event.key ==='Enter')fetchList(categoryCode, keyword, 0);
                    }} />
                <button type="submit" className="search_btn" onClick={(event)=>fetchList(categoryCode, keyword, 0)}></button>
            </div>
            {renderCategory()}
            <div className="listContainer">
                <div className="list">
                    {renderClipArt()}
                    {renderMoreControl()}
                </div>
            </div>
        </div>
    );
}

export default ClipArtTool;